import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

document.addEventListener('DOMContentLoaded', () => {
	Fancybox.bind(".gallery-popup", {
		Thumbs: false,
		mainClass: "gallery-popup-wrapper",
	});
});
